// Los svg comentados quedan a la espera de que se corrijan los archivos para agregarlos

// import { ReactComponent as Assigned } from '../assets/complex-icons/assigned.svg';
import { ReactComponent as Associations } from '../assets/complex-icons/associations.svg';
import { ReactComponent as Bill } from '../assets/complex-icons/bill.svg';
import { ReactComponent as BoxFinish } from '../assets/complex-icons/box-finish.svg';
// import { ReactComponent as Boxes } from '../assets/complex-icons/boxes.svg';
import { ReactComponent as Calendar } from '../assets/complex-icons/complex-calendar.svg';
import { ReactComponent as Check } from '../assets/complex-icons/complex-check.svg';
import { ReactComponent as Clock } from '../assets/complex-icons/complex-clock.svg';
import { ReactComponent as Config } from '../assets/complex-icons/config.svg';
import { ReactComponent as CurrentStock } from '../assets/complex-icons/current-stock.svg';
import { ReactComponent as Destination } from '../assets/complex-icons/destination.svg';
import { ReactComponent as Detail } from '../assets/complex-icons/detail.svg';
import { ReactComponent as DocumentAdd } from '../assets/complex-icons/document-add-complex.svg';
// import { ReactComponent as DownloadApp } from '../assets/complex-icons/download-app.svg';
import { ReactComponent as Error } from '../assets/complex-icons/error.svg';
import { ReactComponent as Expired } from '../assets/complex-icons/expired.svg';
// import { ReactComponent as Eye } from '../assets/complex-icons/eye.svg';
import { ReactComponent as General } from '../assets/complex-icons/general.svg';
import { ReactComponent as Historic } from '../assets/complex-icons/historic.svg';
import { ReactComponent as Hourglass } from '../assets/complex-icons/hourglass.svg';
import { ReactComponent as HubPoint } from '../assets/complex-icons/hub-point.svg';
import { ReactComponent as InDelivery } from '../assets/complex-icons/in-delivery.svg';
import { ReactComponent as InDeposit } from '../assets/complex-icons/in-deposit.svg';
import { ReactComponent as InProgress } from '../assets/complex-icons/in-progress.svg';
// import { ReactComponent as OrdersReady } from '../assets/complex-icons/orders-ready.svg';
import { ReactComponent as Pending } from '../assets/complex-icons/pending.svg';
// import { ReactComponent as Picker } from '../assets/complex-icons/picker.svg';
import { ReactComponent as Picture } from '../assets/complex-icons/picture.svg';
import { ReactComponent as Point } from '../assets/complex-icons/point.svg';
import { ReactComponent as Pricing } from '../assets/complex-icons/pricing.svg';
import { ReactComponent as Profits } from '../assets/complex-icons/profits.svg';
// import { ReactComponent as Schedule } from '../assets/complex-icons/schedule.svg';
// import { ReactComponent as ScheduleSelection } from '../assets/complex-icons/schedule-selection.svg';
import { ReactComponent as Service } from '../assets/complex-icons/service.svg';
// import { ReactComponent as Stock } from '../assets/complex-icons/stock.svg';
import { ReactComponent as StockControl } from '../assets/complex-icons/stock-control.svg';
import { ReactComponent as StockMovement } from '../assets/complex-icons/stock-movement.svg';
import { ReactComponent as Support } from '../assets/complex-icons/complex-support.svg';
import { ReactComponent as Transactions } from '../assets/complex-icons/transactions.svg';
import { ReactComponent as TruckDelivery } from '../assets/complex-icons/truck-delivery.svg';
// import { ReactComponent as Unassigned } from '../assets/complex-icons/unassigned.svg';
import { ReactComponent as Visualization } from '../assets/complex-icons/visualization.svg';
import { ReactComponent as Withheld } from '../assets/complex-icons/withheld.svg';
import { ReactComponent as DevDom } from '../assets/complex-icons/dev-a-dom.svg';
import { ReactComponent as DevPunto } from '../assets/complex-icons/dev-a-punto.svg';
import { ReactComponent as DevSameday } from '../assets/complex-icons/dev-sameday.svg';

export const icons = {
  // assigned: Assigned,
  associations: Associations,
  bill: Bill,
  'box-finish': BoxFinish,
  // boxes: Boxes,
  calendar: Calendar,
  check: Check,
  clock: Clock,
  config: Config,
  'current-stock': CurrentStock,
  destination: Destination,
  detail: Detail,
  'dev-a-dom': DevDom,
  'dev-a-punto': DevPunto,
  'dev-sameday': DevSameday,
  'document-add': DocumentAdd,
  // 'download-app': DownloadApp,
  error: Error,
  expired: Expired,
  // eye: Eye,
  general: General,
  historic: Historic,
  hourglass: Hourglass,
  'in-delivery': InDelivery,
  'in-deposit': InDeposit,
  'in-progress': InProgress,
  'hub-point': HubPoint,
  // 'orders-ready': OrdersReady,
  pending: Pending,
  // picker: Picker,
  picture: Picture,
  point: Point,
  pricing: Pricing,
  profits: Profits,
  // schedule: Schedule,
  // 'schedule-selection': ScheduleSelection,
  service: Service,
  // stock: Stock,
  'stock-control': StockControl,
  'stock-movement': StockMovement,
  support: Support,
  transactions: Transactions,
  'truck-delivery': TruckDelivery,
  // unassigned: Unassigned,
  visualization: Visualization,
  withheld: Withheld,
};
